// extracted by css-extract-rspack-plugin
export default {"successMessage":"pQoHO1ZO2MhhDUBf"};